module.exports = __webpack_public_path__ + "img/Electra.8eb40a42.svg";